import { render } from "./item-detail.vue?vue&type=template&id=8c3aba8c&scoped=true"
import script from "./item-detail.vue?vue&type=script&lang=ts"
export * from "./item-detail.vue?vue&type=script&lang=ts"

import "./item-detail.vue?vue&type=style&index=0&id=8c3aba8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c3aba8c"

export default script